import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import "./VideoFrame.css";
import { useParams } from "react-router-dom";
import {
  url,
  allVideosParam,
  categories,
  upVoteIncrease,
  upVoteDecrease,
  downVoteIncrease,
  downVoteDecrease,
} from "../config";

export const VideoFrame = (props) => {
  const params = useParams();
  const {
    id,
    title,
    src,
    viewCount,
    time,
    upV,
    downV,
    genre,
    patchFunc,
  } = props;
  const [toggle1, setToggle1] = useState(false);
  const [toggle2, setToggle2] = useState(false);

  const handleClick1 = async () => {
    setToggle1(!toggle1);
    if (toggle2) {
      await patchFunc(
        url + allVideosParam + `/${params.id}/` + categories.votes,
        downVoteDecrease
      );
    }
    setToggle2(false);
    patchFunc(
      url + allVideosParam + `/${params.id}/` + categories.votes,
      toggle1 ? upVoteDecrease : upVoteIncrease
    );
  };
  const handleClick2 = async () => {
    setToggle2(!toggle2);
    if (toggle1) {
      await patchFunc(
        url + allVideosParam + `/${params.id}/` + categories.votes,
        upVoteDecrease
      );
    }
    setToggle1(false);
    patchFunc(
      url + allVideosParam + `/${params.id}/` + categories.votes,
      toggle2 ? downVoteDecrease : downVoteIncrease
    );
  };

  return (
    <>
      <Box sx={{ px: 10 }} bgcolor="#181818">
        <Box height="50vh" sx={{ paddingTop: 10, py: 2 }}>
          <iframe
            name="iframe"
            id={id}
            title={title}
            height="100%"
            width="100%"
            src={"https://www." + src}
            style={{ border: 0, borderRadius: "10px" }}
            sandbox="allow-scripts allow-same-origin"
          />
        </Box>

        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column">
            <Typography fontSize="24px" fontWeight="700" color="#FFFF">
              {title}
            </Typography>
            <Stack direction="row" alignItems="center">
              <Typography fontSize="14px" fontWeight="400" color="#C2C2C2">
                +{viewCount}
              </Typography>
              <Box
                height="6px"
                width="6px"
                borderRadius="6px"
                bgcolor="#C2C2C2"
                mx="10px"
              ></Box>
              <Typography fontSize="14px" fontWeight="400" color="#C2C2C2">
                {genre}
              </Typography>
              <Box
                height="6px"
                width="6px"
                borderRadius="6px"
                bgcolor="#C2C2C2"
                mx="10px"
              ></Box>
              <Typography fontSize="14px" fontWeight="400" color="#C2C2C2">
                {time < 12
                  ? `${time} Months`
                  : `${Math.round(time / 12)} Year/s`}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row">
            <Box
              component="button"
              mx="10px"
              className={toggle1 ? "toggleOne" : "toggleTwo"}
              // disabled={toggle1 ? true : false}
              onClick={() => handleClick1()}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M3.03394 5.64795H1.15894C0.830811 5.64795 0.596436 5.90576 0.596436 6.21045V11.8354C0.596436 12.1636 0.830811 12.3979 1.15894 12.3979H3.03394C3.33862 12.3979 3.59644 12.1636 3.59644 11.8354V6.21045C3.59644 5.90576 3.33862 5.64795 3.03394 5.64795ZM2.09644 11.4604C1.76831 11.4604 1.53394 11.2261 1.53394 10.8979C1.53394 10.5933 1.76831 10.3354 2.09644 10.3354C2.40112 10.3354 2.65894 10.5933 2.65894 10.8979C2.65894 11.2261 2.40112 11.4604 2.09644 11.4604ZM9.59644 2.31982C9.59644 0.585449 8.47144 0.397949 7.90894 0.397949C7.41675 0.397949 7.20581 1.33545 7.11206 1.75732C6.97144 2.27295 6.85425 2.78857 6.50269 3.14014C5.75269 3.91357 5.35425 4.87451 4.41675 5.78857C4.36987 5.85889 4.34644 5.9292 4.34644 5.99951V11.0151C4.34644 11.1558 4.46362 11.2729 4.60425 11.2964C4.97925 11.2964 5.47144 11.5073 5.84644 11.6714C6.59644 11.9995 7.5105 12.3979 8.6355 12.3979H8.70581C9.71362 12.3979 10.9089 12.3979 11.3777 11.7183C11.5886 11.437 11.6355 11.0854 11.5183 10.6636C11.9167 10.2651 12.1042 9.51514 11.9167 8.90576C12.3152 8.3667 12.3621 7.59326 12.1277 7.0542C12.4089 6.77295 12.5964 6.32764 12.573 5.90576C12.573 5.1792 11.9636 4.52295 11.1902 4.52295H8.79956C8.98706 3.8667 9.59644 3.3042 9.59644 2.31982Z" />
              </svg>
              {upV}
            </Box>
            <Box
              component="button"
              className={toggle2 ? "toggleOne" : "toggleTwo"}
              // disabled={toggle2 ? true : false}
              onClick={() => handleClick2()}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0.494141 1.70959V7.33459C0.494141 7.66272 0.728516 7.89709 1.05664 7.89709H2.93164C3.23633 7.89709 3.49414 7.66272 3.49414 7.33459V1.70959C3.49414 1.40491 3.23633 1.14709 2.93164 1.14709H1.05664C0.728516 1.14709 0.494141 1.40491 0.494141 1.70959ZM1.43164 6.39709C1.43164 6.09241 1.66602 5.83459 1.99414 5.83459C2.29883 5.83459 2.55664 6.09241 2.55664 6.39709C2.55664 6.72522 2.29883 6.95959 1.99414 6.95959C1.66602 6.95959 1.43164 6.72522 1.43164 6.39709ZM7.80664 12.3971C8.36914 12.3971 9.49414 12.2096 9.49414 10.4987C9.49414 9.51428 8.88477 8.95178 8.69727 8.27209H11.0879C11.8613 8.27209 12.4707 7.63928 12.4941 6.91272C12.4941 6.49084 12.3066 6.04553 12.0254 5.76428C12.2598 5.22522 12.2129 4.45178 11.8145 3.91272C12.002 3.30334 11.8145 2.55334 11.416 2.15491C11.5332 1.73303 11.4863 1.38147 11.2754 1.10022C10.8066 0.420532 9.61133 0.397095 8.60352 0.397095H8.5332C7.4082 0.420532 6.49414 0.81897 5.74414 1.14709C5.36914 1.31116 4.87695 1.52209 4.50195 1.52209C4.36133 1.54553 4.24414 1.66272 4.24414 1.80334V6.81897C4.24414 6.91272 4.26758 6.98303 4.31445 7.02991C5.25195 7.94397 5.65039 8.90491 6.40039 9.67834C6.75195 10.0299 6.86914 10.5455 7.00977 11.0612C7.10352 11.483 7.31445 12.3971 7.80664 12.3971Z" />
              </svg>

              {downV}
            </Box>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};
